import _ from 'lodash';

import {
  PAYMENT_ADJUSTMENT_TYPES,
  TPaymentAdjustmentTypes,
} from '../store/V2/SettingsSlice';
import {
  TZoomMeetingRequestRequestedByRole,
  TZoomMeetingRequestStatus,
  TZoomMeetingRequestTutorPaymentStatus,
  TZoomMeetingRequestType,
  ZOOM_MEETING_REQUEST_REQUESTED_BY_ROLES,
  ZOOM_MEETING_REQUEST_STATUSES,
  ZOOM_MEETING_REQUEST_TUTOR_PAYMENT_STATUSES,
  ZOOM_MEETING_REQUEST_TYPES,
} from '../store/V2/ZoomRequestsSlice';
import {
  LESSON_TYPES,
  ON_BEHALF_USER_ROLES,
  TLessonTypes,
  TOnBehalfOfUserRole,
  TZoomMeetingSectionPaymentType,
  ZOOM_MEETING_SECTION_PAYMENT_TYPES,
} from '../store/V2/SectionSlice';
import { TQuestionDifficulty } from '../store/QuestionSlice';
import Countries from './Countries';
import { INVOICE_STATUSES, TInvoiceStatus } from '../store/V2/InvoicesSlice';
import {
  ONE_TO_ONE_TUTOR_RATE_VERSION_CONDITION_TYPES,
  ONE_TO_ONE_TUTOR_RATE_VERSION_STUDENT_ASSIGNED_DATE_CONDITIONS,
  TOneToOneTutorRateVersionConditionTypes,
  TOneToOneTutorRateVersionStudentAssignedDateConditionTypes,
} from '../store/V2/OneToOneTutorRateVersionsSlice';
import {
  COURSE_STUDENT_PRICING_TYPES,
  TCourseStudentPricingType,
} from '../store/V2/CourseStudentsSlice';
import {
  GROUP_TUTOR_RATE_VERSION_CONDITION_TYPES,
  GROUP_TUTOR_RATE_VERSION_TUTOR_REGISTRATION_DATE_CONDITIONS,
  TGroupTutorRateVersionConditionTypes,
  TGroupTutorRateVersionTutorRegistrationDateConditionTypes,
} from '../store/V2/GroupTutorRateVersionsSlice';
import { ENV_TYPES } from './Configs';
import {
  FLEXIBLE_PLAN_EXPIRED_IN_TYPES,
  FLEXIBLE_PLAN_STATUSES,
  TFlexiblePlanExpiredInTypes,
  TFlexiblePlanStatuses,
} from '../store/V2/FlexiblePlansSlice';
import {
  SUBSCRIPTION_PLAN_BILLING_PERIOD_TYPES,
  SUBSCRIPTION_PLAN_CRITERIAS,
  SUBSCRIPTION_PLAN_STATUSES,
  TSubscriptionPlanBillingPeriodTypes,
  TSubscriptionPlanCriterias,
  TSubscriptionPlanStatuses,
} from '../store/V2/SubscriptionPlansSlice';
import {
  GROUPS_FLEXIBLE_PLAN_CRITERIAS,
  GROUPS_STATUSES,
  GROUPS_SUBSCRIPTION_PLAN_CRITERIAS,
  TGroupsFlexiblePlanCriterias,
  TGroupsStatuses,
  TGroupsSubscriptionPlanCriterias,
} from '../store/V2/GroupsSlice';
import {
  COURSE_PERMISSION_TEMPLATE_GROUP_CRITERIAS,
  COURSE_PERMISSION_TEMPLATE_ROLE_CRITERIAS,
  COURSE_PERMISSION_TEMPLATE_USER_CRITERIAS,
  TCoursePermissionTemplateGroupCriterias,
  TCoursePermissionTemplateRoleCriterias,
  TCoursePermissionTemplateUserCriterias,
} from '../store/V2/CoursePermissionTemplatesSlice';
import {
  COURSE_PRICING_TEMPLATE_SUBSCRIPTION_PRICING_BILLING_PERIOD_TYPES,
  TCoursePricingTemplateSubscriptionPricingBillingPeriodTypes,
} from '../store/V2/CoursePricingTemplatesSlice';
import {
  COURSE_TUTOR_TYPES,
  TCourseTutorType,
} from '../store/V2/CourseTutorsSlice';
import {
  LESSON_HISTORY_TUTOR_PAYMENT_STATUSES,
  TLessonHistoryTutorPaymentStatus,
} from '../store/V2/LessonHistorySlice';
import {
  PENALTY_WAIVER_PAYMENT_STATUSES,
  PENALTY_WAIVER_TYPES,
  TPenaltyWaiverPaymentStatus,
  TPenaltyWaiverTypes,
} from '../store/V2/PenaltyWaiverSlice';

export interface ISelectedOption {
  label: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ISelectedDataOption {
  selectedItem: ISelectedOption;
  options: ISelectedOption[];
}

export const allSelectedOption: ISelectedOption = {
  label: 'All',
  value: 'All',
};

export const defaultEmptySelectedOption: ISelectedOption = {
  label: '',
  value: '',
};

export const defaultSelectedDataOption: ISelectedDataOption = {
  selectedItem: defaultEmptySelectedOption,
  options: [],
};

export const questionDifficultyOptions: Array<TQuestionDifficulty> = [
  'EASY',
  'MEDIUM',
  'HARD',
];

export const adminCancellationReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const adminRescheduleReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const classCancellationReasonOptions = [
  { value: 'Schedule Changes', label: 'Schedule Changes' },
  { value: 'School Events', label: 'School Events' },
  { value: 'Health Reasons', label: 'Health Reasons' },
  { value: 'Vacations', label: 'Vacations' },
];

export const rescheduleReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const classDurationsInMinutes = [
  15,
  30,
  45,
  60,
  75,
  90,
  105,
  120,
  135,
  150,
  165,
  180,
];

if (process.env.REACT_APP_ENV !== ENV_TYPES.PRODUCTION) {
  classDurationsInMinutes.unshift(5);
  classDurationsInMinutes.unshift(3);
}

export const classDurationOptions = classDurationsInMinutes.map((minutes) => {
  const _hours = Math.floor(minutes / 60);
  const _minutes = minutes % 60;

  let label = '';

  if (_hours) {
    label += `${_hours} h `;
  }

  if (_minutes) {
    label += `${_minutes} m`;
  }

  return {
    label,
    value: minutes.toString(),
  };
});

export const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
];

export const countriesOptions = Countries.map((item) => ({
  label: item.name,
  value: item.value,
}));

export type TCountryNameOption = {
  label: string;
  value: string;
};

const constructCountryNameOptions = () => {
  const list: Array<TCountryNameOption> = [];

  Countries.forEach((countryItem) => {
    const isCountryExist = list.some(
      (item) => item.label === countryItem.countryName
    );

    if (!isCountryExist) {
      list.push({
        label: countryItem.countryName,
        value: countryItem.countryName,
      });
    }
  });

  return _.sortBy(list, ['label']);
};

export const countryNameOptions = constructCountryNameOptions();

export const teachingStatusOptions = [
  { value: 'Full-time Tutor', label: 'Full-time Tutor' },
  { value: 'Part-time Tutor', label: 'Part-time Tutor' },
  { value: 'Ex-MOE SG School', label: 'Ex-MOE SG School' },
  { value: 'Ex-School Teacher', label: 'Ex-School Teacher' },
  {
    value: 'Teacher current School Teacher',
    label: 'Teacher current School Teacher',
  },
  { value: 'Current MOE', label: 'Current MOE' },
];

export const availabilityOptions = [
  { value: 'available', label: 'Available for Trials' },
  { value: 'notAvailable', label: 'Unavailable for Trials' },
  { value: 'onABreak', label: 'On a Break' },
  { value: 'resigned', label: 'Resigned' },
  // { value: 'automatedTrainingStage', label: 'Automated training stage' },
  { value: 'demoStage', label: 'Demo Stage' },
  { value: 'notAvailableAdmin', label: 'Unavailable for Trials (Admin)' },
  { value: 'notInterested', label: 'Not Interested for Trials' },
];

export const yesOrNoBoolOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const noticePeriodOptions = Array.from({ length: 24 }, (v, i) => ({
  label: `${i + 1} Hour${i + 1 > 1 ? 's' : ''}`,
  value: i + 1,
}));

const tutorStrengths = [
  'Strong Communication Skills',
  'Patient',
  'Good Rapport with Students',
  'Own Teaching materials',
  'Motivating & friendly',
  "Customize Tuition for Student's needs",
  'Firm Tutor',
  'Passionate',
  'Eager to help',
  'Interactive teaching style',
  'Active Listener',
  'Active teacher',
  'Strong teaching resources',
];

export const strengthOptions = tutorStrengths.map((strength) => ({
  value: strength,
  label: strength,
}));

export const LANGUAGES = [
  'Abkhaz',
  'Afar',
  'Afrikaans',
  'Akan',
  'Albanian',
  'Amharic',
  'Arabic',
  'Aragonese',
  'Armenian',
  'Assamese',
  'Avaric',
  'Avestan',
  'Aymara',
  'Azerbaijani',
  'Bambara',
  'Bashkir',
  'Basque',
  'Belarusian',
  'Bengali',
  'Bihari',
  'Bislama',
  'Bosnian',
  'Breton',
  'Bulgarian',
  'Burmese',
  'Catalan, Valencian',
  'Chamorro',
  'Chechen',
  'Chichewa, Chewa, Nyanja',
  'Chinese',
  'Chuvash',
  'Cornish',
  'Corsican',
  'Cree',
  'Croatian',
  'Czech',
  'Danish',
  'Divehi, Dhivehi, Maldivian',
  'Dutch',
  'English',
  'Esperanto',
  'Estonian',
  'Ewe',
  'Faroese',
  'Fijian',
  'Finnish',
  'French',
  'Fula, Fulah, Pulaar, Pular',
  'Galician',
  'Georgian',
  'German',
  'Greek, Modern',
  'Guaraní',
  'Gujarati',
  'Haitian, Haitian Creole',
  'Hausa',
  'Hebrew (modern)',
  'Herero',
  'Hindi',
  'Hiri Motu',
  'Hungarian',
  'Interlingua',
  'Indonesian',
  'Interlingue',
  'Irish',
  'Igbo',
  'Inupiaq',
  'Ido',
  'Icelandic',
  'Italian',
  'Inuktitut',
  'Japanese',
  'Javanese',
  'Kalaallisut, Greenlandic',
  'Kannada',
  'Kanuri',
  'Kashmiri',
  'Kazakh',
  'Khmer',
  'Kikuyu, Gikuyu',
  'Kinyarwanda',
  'Kirghiz, Kyrgyz',
  'Komi',
  'Kongo',
  'Korean',
  'Kurdish',
  'Kwanyama, Kuanyama',
  'Latin',
  'Luxembourgish, Letzeburgesch',
  'Luganda',
  'Limburgish, Limburgan, Limburger',
  'Lingala',
  'Lao',
  'Lithuanian',
  'Luba-Katanga',
  'Latvian',
  'Manx',
  'Macedonian',
  'Malagasy',
  'Malay',
  'Malayalam',
  'Maltese',
  'Māori',
  'Marathi (Marāṭhī)',
  'Marshallese',
  'Mongolian',
  'Nauru',
  'Navajo, Navaho',
  'Norwegian Bokmål',
  'North Ndebele',
  'Nepali',
  'Ndonga',
  'Norwegian Nynorsk',
  'Norwegian',
  'Nuosu',
  'South Ndebele',
  'Occitan',
  'Ojibwe, Ojibwa',
  'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
  'Oromo',
  'Oriya',
  'Ossetian, Ossetic',
  'Panjabi, Punjabi',
  'Pāli',
  'Persian',
  'Polish',
  'Pashto, Pushto',
  'Portuguese',
  'Quechua',
  'Romansh',
  'Kirundi',
  'Romanian, Moldavian, Moldovan',
  'Russian',
  'Sanskrit (Saṁskṛta)',
  'Sardinian',
  'Sindhi',
  'Northern Sami',
  'Samoan',
  'Sango',
  'Serbian',
  'Scottish Gaelic, Gaelic',
  'Shona',
  'Sinhala, Sinhalese',
  'Slovak',
  'Slovene',
  'Somali',
  'Southern Sotho',
  'Spanish, Castilian',
  'Sundanese',
  'Swahili',
  'Swati',
  'Swedish',
  'Tamil',
  'Telugu',
  'Tajik',
  'Thai',
  'Tigrinya',
  'Tibetan Standard, Tibetan, Central',
  'Turkmen',
  'Tagalog',
  'Tswana',
  'Tonga (Tonga Islands)',
  'Turkish',
  'Tsonga',
  'Tatar',
  'Twi',
  'Tahitian',
  'Uighur, Uyghur',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Venda',
  'Vietnamese',
  'Volapük',
  'Walloon',
  'Welsh',
  'Wolof',
  'Western Frisian',
  'Xhosa',
  'Yiddish',
  'Yoruba',
  'Zhuang, Chuang',
];

export const languageOptions = LANGUAGES.map((item) => ({
  value: item,
  label: item,
}));

const Proficiency = ['Native', 'Intermediate', 'Advanced'];

export const proficiencyOptions = Proficiency.map((pro) => ({
  value: pro,
  label: pro,
}));

export type TOnBehalfOfUserRoleOption = {
  label: TOnBehalfOfUserRole;
  value: TOnBehalfOfUserRole;
};

export const onBehalfOfuserRoleOptions: TOnBehalfOfUserRoleOption[] = (Object.keys(
  ON_BEHALF_USER_ROLES
) as TOnBehalfOfUserRole[]).map((item) => ({
  label: item,
  value: item,
}));

export type TZoomMeetingRequestRequestedByRoleOption = {
  label: TZoomMeetingRequestRequestedByRole;
  value: TZoomMeetingRequestRequestedByRole;
};

export const zoomMeetingRequestRequestedByRoleOptions: TZoomMeetingRequestRequestedByRoleOption[] = Object.values(
  ZOOM_MEETING_REQUEST_REQUESTED_BY_ROLES
).map((item) => ({
  label: item as TZoomMeetingRequestRequestedByRole,
  value: item as TZoomMeetingRequestRequestedByRole,
}));

export type TZoomMeetingRequestStatusOption = {
  label: TZoomMeetingRequestStatus;
  value: TZoomMeetingRequestStatus;
};

export const zoomMeetingRequestStatusOptions = Object.values(
  ZOOM_MEETING_REQUEST_STATUSES
).map((item) => ({
  label: item as TZoomMeetingRequestStatus,
  value: item as TZoomMeetingRequestStatus,
}));

export type TZoomMeetingRequestTypeOption = {
  label: TZoomMeetingRequestType;
  value: TZoomMeetingRequestType;
};

export const zoomMeetingRequestTypeOptions = Object.values(
  ZOOM_MEETING_REQUEST_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TFlexiblePlanStatusOption = {
  label: TFlexiblePlanStatuses;
  value: TFlexiblePlanStatuses;
};

export const flexiblePlanStatusOptions: TFlexiblePlanStatusOption[] = Object.values(
  FLEXIBLE_PLAN_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TFlexiblePlanExpiredInTypeOption = {
  label: TFlexiblePlanExpiredInTypes;
  value: TFlexiblePlanExpiredInTypes;
};

export const flexiblePlanExpiredInTypeOptions: TFlexiblePlanExpiredInTypeOption[] = Object.values(
  FLEXIBLE_PLAN_EXPIRED_IN_TYPES
)
  .map((item) => ({
    label: item,
    value: item,
  }))
  .filter((item) => {
    if (item.value === FLEXIBLE_PLAN_EXPIRED_IN_TYPES.MINUTES) {
      return process.env.REACT_APP_ENV !== ENV_TYPES.PRODUCTION;
    }

    return true;
  });

export type TSubscriptionPlanStatusOption = {
  label: TSubscriptionPlanStatuses;
  value: TSubscriptionPlanStatuses;
};

export const subscriptionPlanStatusOptions: TSubscriptionPlanStatusOption[] = Object.values(
  SUBSCRIPTION_PLAN_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TSubscriptionPlanBillingPeriodTypeOption = {
  label: TSubscriptionPlanBillingPeriodTypes;
  value: TSubscriptionPlanBillingPeriodTypes;
};

export const subscriptionPlanBillingPeriodOptions: TSubscriptionPlanBillingPeriodTypeOption[] = Object.values(
  SUBSCRIPTION_PLAN_BILLING_PERIOD_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TSubscriptionPlanCriteriaOption = {
  label: TSubscriptionPlanCriterias;
  value: TSubscriptionPlanCriterias;
};

export const subscriptionPlanCriteriaOptions: TSubscriptionPlanCriteriaOption[] = Object.values(
  SUBSCRIPTION_PLAN_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

export type TGroupStatusOption = {
  label: TGroupsStatuses;
  value: TGroupsStatuses;
};

export const groupStatusOptions: TGroupStatusOption[] = Object.values(
  GROUPS_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TGroupsFlexiblePlanCriteriaOption = {
  label: TGroupsFlexiblePlanCriterias;
  value: TGroupsFlexiblePlanCriterias;
};

export const groupFlexiblePlanCriteriaOptions: TGroupsFlexiblePlanCriteriaOption[] = Object.values(
  GROUPS_FLEXIBLE_PLAN_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

export type TGroupsSubscriptionPlanCriteriaOption = {
  label: TGroupsSubscriptionPlanCriterias;
  value: TGroupsSubscriptionPlanCriterias;
};

export const groupSubscriptionPlanCriteriaOptions: TGroupsSubscriptionPlanCriteriaOption[] = Object.values(
  GROUPS_SUBSCRIPTION_PLAN_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

// COURSE PERMISSION TEMPLATES
export type TCoursePermissionTemplateRoleCriteraOption = {
  label: TCoursePermissionTemplateRoleCriterias;
  value: TCoursePermissionTemplateRoleCriterias;
};

export const coursePermissionTemplateRoleCriteriaOptions: TCoursePermissionTemplateRoleCriteraOption[] = Object.values(
  COURSE_PERMISSION_TEMPLATE_ROLE_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

export type TCoursePermissionTemplateGroupCriteraOption = {
  label: TCoursePermissionTemplateGroupCriterias;
  value: TCoursePermissionTemplateGroupCriterias;
};

export const coursePermissionTemplateGroupCriteriaOptions: TCoursePermissionTemplateGroupCriteraOption[] = Object.values(
  COURSE_PERMISSION_TEMPLATE_GROUP_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

export type TCoursePermissionTemplateUserCriteraOption = {
  label: TCoursePermissionTemplateUserCriterias;
  value: TCoursePermissionTemplateUserCriterias;
};

export const coursePermissionTemplateUserCriteriaOptions: TCoursePermissionTemplateUserCriteraOption[] = Object.values(
  COURSE_PERMISSION_TEMPLATE_USER_CRITERIAS
).map((item) => ({
  label: item,
  value: item,
}));

export type TCoursePricingTemplateBillingPeriodOption = {
  label: TCoursePricingTemplateSubscriptionPricingBillingPeriodTypes;
  value: TCoursePricingTemplateSubscriptionPricingBillingPeriodTypes;
};

export const coursePricingTemplateBillingPeriodOptions: TCoursePricingTemplateBillingPeriodOption[] = Object.values(
  COURSE_PRICING_TEMPLATE_SUBSCRIPTION_PRICING_BILLING_PERIOD_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export const trialStatusOptions = [
  { value: 'SUCCEED', label: 'SUCCEED' },
  { value: 'COMPLETED', label: 'COMPLETED' },
  { value: 'SCHEDULED', label: 'SCHEDULED' },
  { value: 'PENDING', label: 'PENDING' },
  { value: 'CANCELED', label: 'CANCELED' },
];

const TUTOR_LEVEL_COLORS = {
  'Level 1': '#64fb34',
  'Level 2': '#0404fb',
  'Level 3': '#f865f8',
  'Level 4': '#fbfb04',
  'Level 5': '#58ffdc',
  'Level 6': '#fc0404',
};

export const tutorLevelOptions = Object.keys(TUTOR_LEVEL_COLORS).map(
  (tutorLevel) => ({
    label: tutorLevel,
    value: tutorLevel,
  })
);

export const roleOptions = [
  { label: 'Student', value: 'Student' },
  { label: 'Tutor', value: 'Tutor' },
  { label: 'Admin', value: 'Admin' },
];

export const userRoleTypes = [
  { label: 'Admin', value: 'admin' },
  { label: 'User', value: 'user' },
];

export type TInvoiceStatusOption = {
  label: TInvoiceStatus;
  value: TInvoiceStatus;
};

export const invoiceStatusOptions: TInvoiceStatusOption[] = Object.values(
  INVOICE_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TPaymentAdjustmentTypeOption = {
  label: TPaymentAdjustmentTypes;
  value: TPaymentAdjustmentTypes;
};

export const paymentAdjustmentTypeOptions: TPaymentAdjustmentTypeOption[] = Object.values(
  PAYMENT_ADJUSTMENT_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TOneToOneTutorRateVersionConditionTypeOption = {
  label: TOneToOneTutorRateVersionConditionTypes;
  value: TOneToOneTutorRateVersionConditionTypes;
};

export const oneToOneTutorRateVersionConditionTypeOptions: TOneToOneTutorRateVersionConditionTypeOption[] = Object.values(
  ONE_TO_ONE_TUTOR_RATE_VERSION_CONDITION_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TGroupTutorRateVersionConditionTypeOption = {
  label: TGroupTutorRateVersionConditionTypes;
  value: TGroupTutorRateVersionConditionTypes;
};

export const groupTutorRateVersionConditionTypeOptions: TGroupTutorRateVersionConditionTypeOption[] = Object.values(
  GROUP_TUTOR_RATE_VERSION_CONDITION_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TOneToOneTutorRateVersionStudentAssignedDateConditionTypeOption = {
  label: TOneToOneTutorRateVersionStudentAssignedDateConditionTypes;
  value: TOneToOneTutorRateVersionStudentAssignedDateConditionTypes;
};

export const oneToOneTutorRateVersionStudentAssignedDateConditionTypeOptions: TOneToOneTutorRateVersionStudentAssignedDateConditionTypeOption[] = Object.values(
  ONE_TO_ONE_TUTOR_RATE_VERSION_STUDENT_ASSIGNED_DATE_CONDITIONS
).map((item) => ({
  label: item,
  value: item,
}));

export type TGroupTutorRateVersionTutorRegistrationDateConditionTypeOption = {
  label: TGroupTutorRateVersionTutorRegistrationDateConditionTypes;
  value: TGroupTutorRateVersionTutorRegistrationDateConditionTypes;
};

export const groupTutorRateVersionTutorRegistrationDateConditionTypeOptions: TGroupTutorRateVersionTutorRegistrationDateConditionTypeOption[] = Object.values(
  GROUP_TUTOR_RATE_VERSION_TUTOR_REGISTRATION_DATE_CONDITIONS
).map((item) => ({
  label: item,
  value: item,
}));

export type TCourseStudentPricingTypeOption = {
  label: TCourseStudentPricingType;
  value: TCourseStudentPricingType;
};

export const courseStudentPricingTypeOptions: TCourseStudentPricingTypeOption[] = Object.values(
  COURSE_STUDENT_PRICING_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TCourseTutorTypeOption = {
  label: TCourseTutorType;
  value: TCourseTutorType;
};

export const courseTutorTypeOptions: TCourseTutorTypeOption[] = Object.values(
  COURSE_TUTOR_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TLessonHistoryTutorPaymentStatusOption = {
  label: TLessonHistoryTutorPaymentStatus;
  value: TLessonHistoryTutorPaymentStatus;
};

export const lessonHistoryTutorPaymentStatusOptions: TLessonHistoryTutorPaymentStatusOption[] = Object.values(
  LESSON_HISTORY_TUTOR_PAYMENT_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TZoomMeetingSectionPaymentTypeOption = {
  label: TZoomMeetingSectionPaymentType;
  value: TZoomMeetingSectionPaymentType;
};

export const zoomMeetingSectionPaymentTypeOptions: TZoomMeetingSectionPaymentTypeOption[] = Object.values(
  ZOOM_MEETING_SECTION_PAYMENT_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TZoomMeetingLessonTypeOption = {
  label: TLessonTypes;
  value: TLessonTypes;
};

export const zoomMeetingLessonTypeOptions: TZoomMeetingLessonTypeOption[] = Object.values(
  LESSON_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export const tutorPaymentTrialConversationStatusOptions: ISelectedOption[] = [
  {
    label: 'Trial lesson successful - Student enrolled',
    value: 'Trial lesson successful - Student enrolled',
  },
  {
    label: 'Trial lesson was not successful',
    value: 'Trial lesson was not successful',
  },
  {
    label: 'Awaiting confirmation from the parent',
    value: 'Awaiting confirmation from the parent',
  },
  {
    label: 'Pending payment from the parent',
    value: 'Pending payment from the parent',
  },
];

export type TPenaltyWaiverTypeOption = {
  label: TPenaltyWaiverTypes;
  value: TPenaltyWaiverTypes;
};

export const penaltyWaiverTypeOptions: TPenaltyWaiverTypeOption[] = Object.values(
  PENALTY_WAIVER_TYPES
).map((item) => ({
  label: item,
  value: item,
}));

export type TPenaltyWaiverPaymentStatusOption = {
  label: TPenaltyWaiverPaymentStatus;
  value: TPenaltyWaiverPaymentStatus;
};

export const penaltyWaiverPaymentStatusOptions: TPenaltyWaiverPaymentStatusOption[] = Object.values(
  PENALTY_WAIVER_PAYMENT_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));

export type TZoomMeetingRequestTutorPaymentOption = {
  label: TZoomMeetingRequestTutorPaymentStatus;
  value: TZoomMeetingRequestTutorPaymentStatus;
};

export const zoomMeetingRequestTutorPaymentOptions: TZoomMeetingRequestTutorPaymentOption[] = Object.values(
  ZOOM_MEETING_REQUEST_TUTOR_PAYMENT_STATUSES
).map((item) => ({
  label: item,
  value: item,
}));
